<template>
    <v-card style="border-radius: 1em; height: 22em;">
        <v-toolbar color="error" dark>
            <v-icon>warning</v-icon>
            <v-toolbar-title>Atenção</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
            <v-stepper v-model="step" style="box-shadow: none;">
                <v-stepper-items>
                    <v-stepper-content step="1" class="pa-0">
                      <ul style="font-size: 1.2em;">
                        <li>Essa função tem o limite de 50 compras por vez</li>
                        <li>Ao confirmar a realização dessa função você deverá aguardar o carregamento ser concluido</li>
                        <li>Você não poderá recarregar a página</li>
                      </ul>
                        <v-btn color="error" block dark @click="step = 2" class="mt-2">Continuar</v-btn>
                    </v-stepper-content>
                    <v-stepper-content step="2" class="pa-0">
                        <v-layout justify-center align-center column fill-height style="height: 15em;" v-if="!loading">
                            <h3 class="text-xs-center mb-2">PIN do gerente</h3>
                            <v-form lazy-validation v-model="valid" ref="form">
                              <v-layout row justify-center style="margin-bottom: 5em;">
                                      <v-flex xs10>
                                      <v-text-field
                                      :type="show ? 'text' : 'password'"
                                      v-model="pin"
                                      :append-icon="show ? 'visibility' : 'visibility_off'"
                                      placeholder="****"
                                      outline
                                      counter="4"
                                      single-line
                                      hide-details
                                      :color="color"
                                      class="centered-input display-1 font-weight-black"
                                      browser-autocomplete="off"
                                      required
                                      @click:append="show = !show"
                                      :rules="[
                                              v => {
                                                  if (v) {
                                                  return v.length && v.length == 4 || ''
                                                  } else {
                                                  return false
                                                  }
                                              }
                                              ]"
                                      mask="NNNN"
                                      />
                                      </v-flex>
                                      <v-layout row justify-center :class="`mt-${loading ? 2 : 1}`">
                                          <v-btn v-if="!loading" icon :color="color" @click="autenticar"><v-icon>arrow_forward</v-icon></v-btn>
                                          <v-progress-circular
                                              v-else
                                              indeterminate
                                              :color="color"
                                          ></v-progress-circular>
                                      </v-layout>
                              </v-layout>
                              <h3 class="error--text text-xs-center mt-1" v-if="textError">Não foi possível autenticar</h3>
                          </v-form>
                            <v-footer absolute>
                              <v-btn block class="mt-2" @click="$emit('fechar')">Cancelar</v-btn>
                            </v-footer>
                        </v-layout>
                        <v-layout justify-center align-center column fill-height style="height: 15em;" v-else>
                          <h2 class="error--text mb-4">Aguarde o carregamento</h2>
                          <v-progress-circular indeterminate size="100" color="error"></v-progress-circular>
                          <h4 class="error--text mt-4">Função em execução...</h4>
                        </v-layout>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </v-card-text>
    </v-card>
</template>

<script>

export default {
  data () {
    return {
      step: 1,
      show: false,
      valid: false,
      pin: '',
      textError: '',
      color: 'error'
    }
  },
  computed: {
    frentista () {
      return this.$store.getters.frentista
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    autenticar () {
      if (this.pin && this.pin !== '') {
        this.$store.dispatch('autenticarPin', { cnpj: this.frentista.posto.cnpj, pin: this.pin, id: this.frentista.id_frentista }).then(() => {
          this.pin = ''
          this.show = false
          this.$emit('autenticado')
        }).catch(() => {
          this.textError = 'PIN incorreto'
          setInterval(() => {
            this.textError = ''
          }, 3000)
        })
      }
    }
  },
  created () {
    window.addEventListener('keydown', (e) => {
      if (this.loading && ((e.ctrlKey && e.keyCode === 82) || e.keyCode === 116 || (e.shiftKey && e.keyCode === 82))) {
        e.preventDefault()
        alert('Você não pode atualizar a página enquanto estiver realizando essa operação.')
      }
    })
  },
  beforeMount () {
    this.step = 1
  }
}
</script>
